export const homePageEvents = {
    utmEvent: 'utm_tracking_event',
}
